import axios from 'axios';
//import {ENV_CONFIG}

import { BASE_URL } from '../../services/ApiService/ApiConfig.js';

const API_URL = `${BASE_URL}/nomina/empleado`;

// Endpoints específicos
const ENDPOINT_CUENTAS = '/cuentaBan';
const ENDPOINT_FAMILIAR = '/familiar';
// Asegúrate que en Java sea: @RequestMapping("/telefono")
const ENDPOINT_TELEFONO = '/telefono';
const ENDPOINT_UBICACION = '/ubicacion';
const ENDPOINT_EXPERIENCIA = '/experiencia';

const obtenerConfig = () => {
    const tokenRaw = localStorage.getItem('jwt');
    const token = tokenRaw ? tokenRaw.replaceAll('"', '') : '';
    return {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        }
    };
}

// --------------------------------------------------------------------------------
// SERVICIOS DE TELÉFONOS (El problema actual)
// --------------------------------------------------------------------------------

export const obtenerTelefonosPorEmpleado = async (empleadoId) => {
    try {
        const url = `${API_URL}${ENDPOINT_TELEFONO}/${empleadoId}`;
        //console.log("Intentando GET Telefonos en:", url); // DEBUG
        const response = await axios.get(url, obtenerConfig());
        return response.data;
    } catch (error) {
        console.warn('Fallo obteniendo teléfonos. Verifique si el Backend cargó el controlador.', error);
        return [];
    }
}

export const agregarTelefonoAEmpleado = async (telefonoData) => {
    const url = `${API_URL}${ENDPOINT_TELEFONO}`;
    try {
        console.log("Intentando POST Telefono en:", url); // DEBUG
        // OJO: El payload debe coincidir con TelefonoCreateRequest.java
        const response = await axios.post(url, telefonoData, obtenerConfig());
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 404) {
            console.error(`ERROR CRÍTICO 404: El servidor dice que la ruta ${url} NO EXISTE.`);
            console.error("SOLUCIÓN: Detenga el Backend, haga 'Rebuild Project' y vuelva a iniciarlo.");
        }
        throw error;
    }
}

export const actualizarTelefonoEmpleado = async (telefonoData) => {
    const url = `${API_URL}${ENDPOINT_TELEFONO}`;
    try {
        const response = await axios.put(url, telefonoData, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('Error al actualizar teléfono:', error);
        throw error;
    }
}

export const eliminarTelefonoDeEmpleado = async (telefonoId) => {
    const url = `${API_URL}${ENDPOINT_TELEFONO}/${telefonoId}`;
    try {
        await axios.delete(url, obtenerConfig());
        return true;
    } catch (error) {
        console.error('Error al eliminar teléfono:', error);
        throw error;
    }
}

// --------------------------------------------------------------------------------
// SERVICIOS DE FAMILIARES
// --------------------------------------------------------------------------------

export const obtenerFamiliaresPorEmpleado = async (empleadoId) => {
    try {
        const url = `${API_URL}${ENDPOINT_FAMILIAR}/${empleadoId}`;
        const response = await axios.get(url, obtenerConfig()); return response.data;
    } catch (error) {
        console.error('Error obtener familiares:', error);
        return [];
    }
}

export const agregarFamiliarAEmpleado = async (familiarData) => {
    try {
        const url = `${API_URL}${ENDPOINT_FAMILIAR}`;
        const response = await axios.post(url, familiarData, obtenerConfig());
    } catch (error) {
        console.error('Error crear familiar:', error);
        throw error;
    }
}

export const actualizarFamiliarEmpleado = async (familiarData) => {
    try {
        const url = `${API_URL}${ENDPOINT_FAMILIAR}`;
        const response = await axios.put(url, familiarData, obtenerConfig()); return response.data;
    } catch (error) {
        console.error('Error actualizar familiar:', error);
        throw error;
    }
}

export const eliminarFamiliarDeEmpleado = async (familiarId) => {
    try {
        const url = `${API_URL}${ENDPOINT_FAMILIAR}/${familiarId}`;
        await axios.delete(url, obtenerConfig());
        return true;
    } catch (error) {
        console.error('Error eliminar familiar:', error);
        throw error;
    }
}

// --------------------------------------------------------------------------------
// SERVICIOS DE CUENTAS
// --------------------------------------------------------------------------------

export const obtenerCuentasPorEmpleado = async (empleadoId) => {
    try {
        const url = `${API_URL}${ENDPOINT_CUENTAS}/${empleadoId}`;
        const response = await axios.get(url, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('Error al obtener cuentas:', error);
        return [];
    }
}

export const agregarCuentaAEmpleado = async (cuentaData) => {
    try {
        const url = `${API_URL}${ENDPOINT_CUENTAS}`;
        const response = await axios.post(url, cuentaData, obtenerConfig());

        return response.data;
    } catch (error) {
        console.error('Error al crear cuenta:', error);
        throw error;
    }
}

export const actualizarCuentaEmpleado = async (cuentaData) => {
    try {
        const url = `${API_URL}${ENDPOINT_CUENTAS}`;
        const response = await axios.put(url, cuentaData, obtenerConfig());
        return response.data;
    } catch (error) {
        console.error('Error al actualizar cuenta:', error);
        throw error;
    }
}

export const eliminarCuentaDeEmpleado = async (cuentaId) => {
    try {
        const url = `${API_URL}${ENDPOINT_CUENTAS}/${cuentaId}`;
        await axios.delete(url, obtenerConfig());

        return true;
    } catch (error) {
        console.error('Error al eliminar cuenta:', error);
        throw error;
    }
}

// --------------------------------------------------------------------------------
// SERVICIO DE FOTO
// --------------------------------------------------------------------------------

export const subirFotoEmpleado = async (empleadoId, fotoFile) => {
    try {
        const url = `${API_URL}/${empleadoId}/foto`;
        const formData = new FormData();
        formData.append('foto', fotoFile);


        const config = obtenerConfig();
        config.headers['Content-Type'] = 'multipart/form-data';

        const tokenRaw = localStorage.getItem('jwt');
        const token = tokenRaw ? tokenRaw.replaceAll('"', '') : '';

        const response = await axios.post(url, formData, config);
        return response.data;
    } catch (error) {
        console.error('Error en subirFotoEmpleado:', error);
        throw error;
    }
}

/*UBICACION  */
export const obtenerUbicacionesPorEmpleado = async (empleadoId) => {
    try {
        const response = await axios.get(`${API_URL}${ENDPOINT_UBICACION}/${empleadoId}`, obtenerConfig());
        return response.data;
    } catch (error) { return []; }
};

export const agregarUbicacionAEmpleado = async (ubicacionData) => {
    const response = await axios.post(`${API_URL}${ENDPOINT_UBICACION}`, ubicacionData, obtenerConfig());
    return response.data;
};

export const actualizarUbicacionEmpleado = async (ubicacionData) => {
    const response = await axios.put(`${API_URL}${ENDPOINT_UBICACION}`, ubicacionData, obtenerConfig());
    return response.data;
};

export const eliminarUbicacionDeEmpleado = async (id) => {
    await axios.delete(`${API_URL}${ENDPOINT_UBICACION}/${id}`, obtenerConfig());
    return true;
};

/*EXPERIENCIA  */

export const obtenerExperienciasPorEmpleado = async (empleadoId) => {
    try {
        const url = `${API_URL}${ENDPOINT_EXPERIENCIA}/${empleadoId}`;
        const response = await axios.get(url, obtenerConfig());
        return response.data;
    } catch (error) { return []; }
};

export const agregarExperienciaAEmpleado = async (experienciaData) => {
    const url = `${API_URL}${ENDPOINT_EXPERIENCIA}`;
    return (await axios.post(url, experienciaData, obtenerConfig())).data;
};

export const actualizarExperienciaEmpleado = async (experienciaData) => {
    const url = `${API_URL}${ENDPOINT_EXPERIENCIA}`;
    return (await axios.put(url, experienciaData, obtenerConfig())).data;
};

export const eliminarExperienciaDeEmpleado = async (id) => {
    const url = `${API_URL}${ENDPOINT_EXPERIENCIA}/${id}`;
    await axios.delete(url, obtenerConfig());
    return true;
};